export const range = (length: number): number[] => [...Array(length).keys()]
